import { render, staticRenderFns } from "./cmansdetails_view.vue?vue&type=template&id=201b463c&scoped=true"
import script from "./cmansdetails_view.vue?vue&type=script&lang=js"
export * from "./cmansdetails_view.vue?vue&type=script&lang=js"
import style0 from "./cmansdetails_view.vue?vue&type=style&index=0&id=201b463c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201b463c",
  null
  
)

export default component.exports